import { GatewayQuestionnaire } from "@conformite/gateway";

export type RemediationStatus = "NON_SELECTIONNE" | "OUI" | "NON" | "MANQUANT";

export const REMEDIATION_QUESTION_LABEL =
  "Une action de remédiation est-elle nécessaire ?";

export function getRemediationStatus(
  instance?: GatewayQuestionnaire.QuestionnaireInstanceResponse | null
): RemediationStatus {
  const answer = instance?.answers.find(
    (a) => a.label === REMEDIATION_QUESTION_LABEL
  );
  if (!answer?.value) return "NON_SELECTIONNE";

  const selectedLabel = answer.options
    .find((option) => option.id === answer.value)
    ?.label.trim()
    .toLowerCase();

  switch (selectedLabel) {
    case "oui":
      return "OUI";
    case "non":
      return "NON";
    case "manquant":
      return "MANQUANT";
    default:
      return "NON_SELECTIONNE";
  }
}

export function getRemediationStatusFromAnswers(
  definition:
    GatewayQuestionnaire.QuestionnaireDefinitionResponse | null | undefined,
  answers: Record<string, string>
): RemediationStatus {
  const question = definition?.questions.find(
    (q) => q.label === REMEDIATION_QUESTION_LABEL
  );
  if (!question) return "NON_SELECTIONNE";

  const value = answers[question.id];
  if (!value) return "NON_SELECTIONNE";

  const selectedLabel = question.options
    .find((option) => option.id === value)
    ?.label.trim()
    .toLowerCase();

  switch (selectedLabel) {
    case "oui":
      return "OUI";
    case "non":
      return "NON";
    case "manquant":
      return "MANQUANT";
    default:
      return "NON_SELECTIONNE";
  }
}

export type PersonneVerificationStatus =
  "NON_VERIFIE" | "EN_COURS" | "VERT" | "ROUGE" | "ORANGE";

export type AxeRemediationState = {
  status: RemediationStatus;
  hasAnswers: boolean;
};

export function aggregatePersonneVerificationStatus(
  axes: AxeRemediationState[]
): PersonneVerificationStatus {
  if (axes.length === 0) return "NON_VERIFIE";

  const hasStarted = axes.some((axe) => axe.hasAnswers);
  if (!hasStarted) return "NON_VERIFIE";

  const allCompleted = axes.every((axe) => axe.status !== "NON_SELECTIONNE");
  if (!allCompleted) return "EN_COURS";

  if (axes.some((axe) => axe.status === "OUI")) return "ROUGE";
  if (axes.some((axe) => axe.status === "MANQUANT")) return "ORANGE";
  return "VERT";
}
